export const planRatesKeyFactory = {
  recentlyUpdatedRates: (limit: number) => ["recentlyUpdatedRates", limit],
  recentlyUpdatedPlans: (limit: number) => ["recentlyUpdatedPlans", limit],
  planKPIs: () => ["planKPIs"],
  utilityServices: () => ["utilityServices"],
  rateTypes: () => ["rateTypes"],
  rateDetail: (id: string) => ["rateDetail", id],
  versionDetail:(id: string) => ["versionDetail", id],
  planRatesSummary: (remoteUtilityId:string) => ["planRatesSummary",remoteUtilityId],
  entityTypeForParameters: () => ["entityTypeForParameters"],
  sourceModules: (remoteUtilityId:string) => ["sourceModules",remoteUtilityId],
  ValuesForSource: (remoteUtilityId:string,id:string) => ["valuesForSource",remoteUtilityId,id],
  rateStatus: () => ["rateStatus"],
};
